import { forwardRef } from "react"
import { Day } from "@gogoro/go-design"
import { parseISO } from "date-fns"
import { useUser } from "modules/users"
import { dateFormatWithTimezone } from "utils/formatTime"

import { DateRangePickerProps } from "./DateRangePickerProps"
import GenericDateRangePicker from "./GenericDateRangePicker"

interface StringDatePickerProps extends DateRangePickerProps<string> {
  required?: boolean
}

const StringDateRangePicker = ({ name, onChange, value, required, ...restProps }: StringDatePickerProps, ref: any) => {
  const { Timezone } = useUser()

  const formatOutput = (date: Day) => {
    return dateFormatWithTimezone(date, Timezone, "yyyy-MM-dd'T'HH:mm:ssXXX")
  }

  const formatInput = (isoString: string | null) => {
    try {
      if (!isoString) {
        return null
      }

      return parseISO(isoString)
    } catch (e) {
      console.log(e)
    }

    return null
  }

  return (
    <div data-testid={`date-range-picker-${name}`}>
      <GenericDateRangePicker<string>
        name={name}
        onChange={onChange}
        formatInput={formatInput}
        formatOutput={formatOutput}
        value={value}
        clearable={!required}
        myRef={ref}
        {...restProps}
      />
    </div>
  )
}

export default forwardRef(StringDateRangePicker)
